/* eslint-disable no-param-reassign */
import { lightTheme as theme } from '@zenbusiness/zui/styles';

// 100000 => 100,000
export function formatCommaNumber(textNumber) {
  return textNumber.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const convertToCent = (value) => {
  const pureValue = value.replace(/,/g, '').replace(/\./g, '');
  return parseInt(pureValue, 10);
};

export const formatInputValue = (value) => {
  if (value === '' || value === '0' || value === '0.') {
    return '0.00';
  }

  const pureNumber = value.replace(/\D/g, '');

  if (pureNumber.length === 1) {
    return `0.0${pureNumber}`;
  }

  if (pureNumber.length === 2) {
    return `0.${pureNumber}`;
  }

  let firstPart = pureNumber.slice(0, -2);
  if (firstPart !== '0') {
    firstPart = firstPart.replace(/^0+/, '');
  }

  if (firstPart === '') {
    firstPart = '0';
  }

  const lastPart = pureNumber.slice(-2);

  return `${formatCommaNumber(firstPart)}.${formatCommaNumber(lastPart)}`;
};

export function updateFormattedValue(input, formattedValue) {
  const afterCaretPos = formattedValue.length;

  input.value = formattedValue;
  input.setSelectionRange(afterCaretPos, afterCaretPos);
}

export const updateTextColorByValue = (input, formattedValue) => {
  if (formattedValue === '0.00') {
    input.style.color = theme.palette.text.tertiary;
  } else {
    input.style.color = theme.palette.text.primary;
  }
};

// 100000 => 100,000.00
export const convertCentToUSDWithoutSymbol = (number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  if (typeof number !== 'number' || Number.isNaN(number)) {
    return '0.00';
  }
  return formatter.format(number / 100);
};

export const convertCentToUSDWithoutFractionDigits = (number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    style: 'currency',
    currency: 'USD'
  });

  if (typeof number !== 'number' || Number.isNaN(number)) {
    return '$0';
  }
  return formatter.format(number / 100);
};

// input field use , . 0-9 calculate length of input field in ch unit
export const calculateTextLength = (text = '') => {
  const countCommas = (text.match(/,/g) || []).length;
  const countDots = (text.match(/\./g) || []).length;
  const count1 = (text.match(/1/g) || []).length;
  const count7 = (text.match(/[7]/g) || []).length;
  const count02345689 = (text.match(/[02345689]/g) || []).length;

  const totalLength =
    0.45 * countCommas + 0.36 * countDots + 0.72 * count1 + 0.9 * count7 + 1 * count02345689;
  return totalLength;
};
